// Actions
export const PLACEMENT_FETCH  = '[Placement] Fetch'

// Mutations
export const PLACEMENT_META   = '[Placement] meta'
export const PLACEMENT_OBTAIN = '[Placement] obtain'
export const PLACEMENT_CLEAR  = '[Placement] clear'
export const PLACEMENT_SET_LOADING = '[Placement] set loading'
